module.exports = __webpack_public_path__ + "static/aboutimg-15254a9cfdfa1bd0c7d8bd1723e53c81.jpg";